import { useNavigate } from 'react-router-dom';

import { DangerButton } from '../../components/button/DangerButton';
import { SecondaryButton } from '../../components/button/SecondaryButton';
import { Modal } from '../../components/modal/Modal';
import { useDeleteVehicle } from '../../hooks/useDeleteVehicle';
import { t } from '../../services/translation/translation';
import { noop } from '../../utils/common';

type Props = {
  onClose: () => void;
  vehicleId: string;
};

export const DeleteVehicleModal = ({ onClose, vehicleId }: Props) => {
  const navigate = useNavigate();
  const { mutate: deleteVehicle, isLoading } = useDeleteVehicle();

  const handleClose = isLoading ? noop : onClose;

  return (
    <Modal onClose={handleClose}>
      <Modal.Header onClose={handleClose} title={t('vehicle-route.delete-modal.title')} />
      <Modal.Body>
        <p className="text-sm font-normal text-gray-500 dark:text-gray-400">
          {t('vehicle-route.delete-modal.description')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <DangerButton
          onClick={() => deleteVehicle(vehicleId, { onSuccess: () => navigate('/vehicles') })}
          isLoading={isLoading}
        >
          {t('common.delete')}
        </DangerButton>
        <SecondaryButton onClick={handleClose}>{t('common.cancel')}</SecondaryButton>
      </Modal.Footer>
    </Modal>
  );
};
